import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=20f1afab&scoped=true&functional=true"
var script = {}
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=20f1afab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "20f1afab",
  null
  
)

export default component.exports